module.exports = __webpack_public_path__ + "static/og-image-a88ff643b1f26905225f0a50ccf76717.png";